export const PORTAL_ORG_ROLES = [
  "OrganizationAdmin",
  "OrganizationMember",
  "Security",
  "RlSupport",
] as const;
export const PORTAL_GROUP_ROLES = [
  "GroupOwner",
  "Maintainer",
  "GroupMember",
  "GroupObserver",
] as const;

export type PortalOrgRole = (typeof PORTAL_ORG_ROLES)[number];
export type PortalGroupRole = (typeof PORTAL_GROUP_ROLES)[number];

export const TRIAL_ORG_ROLES = [
  "OrganizationAdmin",
  "RlSupport",
  "TrialOrganizationMember",
] as const;
export const TRIAL_GROUP_ROLES = ["TrialGroupMember"] as const;

export type TrialOrgRole = (typeof TRIAL_ORG_ROLES)[number];
export type TrialGroupRole = (typeof TRIAL_GROUP_ROLES)[number];

export type OrgRole = PortalOrgRole | TrialOrgRole;
export type GroupRole = PortalGroupRole | TrialGroupRole;

export type PortalRole =
  | { type: "organization"; value: PortalOrgRole }
  | { type: "group"; value: PortalGroupRole };

export type TrialRole =
  | { type: "organization"; value: TrialOrgRole }
  | { type: "group"; value: TrialGroupRole };

export type Role = PortalRole | TrialRole;
export type Roles = Role[];
